import { FlowComponent } from '../../flow.min.js';
import styles from './styles.js';
import { config } from '../../config.js';

import '../ui/flow-input/flow-input.js';
import '../ui/flow-button/flow-button.js';

const template = FlowComponent.html`
    <form action="${'action'}" method="POST" class="space-y-4">
        <p class="text-sm text-gray-600 mb-4">
            El enlace de verificación ha expirado o no es válido. Ingresa tu correo para recibir uno nuevo.
        </p>
        
        <flow-input
            label="Correo electrónico"
            type="email"
            name="email"
            placeholder="tu@correo.com"
            required="true">
        </flow-input>

        <flow-button type="submit" variant="primary">
            Re-enviar Verificación
        </flow-button>

        <div class="text-center pt-2">
            <a href="#" id="back-to-login" class="text-sm font-medium text-blue-600 hover:text-blue-500">
                Volver al inicio de sesión
            </a>
        </div>
    </form>
`;

export class ResendVerificationForm extends FlowComponent {
    static get styles() { return styles; }
    static get template() { return template; }

    onMount() {
        super.onMount();
        this.action = `/api/v1/registration/resend-verification`;
        
        const form = this.root.querySelector('form');
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.#processSubmit(form);
        });

        const submitBtn = this.root.querySelector('flow-button[type="submit"]');
        if (submitBtn) {
            submitBtn.addEventListener('click', () => {
                if (form.reportValidity()) {
                    form.requestSubmit();
                }
            });
        }

        const backLink = this.root.querySelector('#back-to-login');
        if (backLink) {
            backLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.emit('view:change', { view: 'login' });
            });
        }
    }

    set loading(val) {
        const btn = this.root.querySelector('flow-button[type="submit"]');
        if (btn) btn.loading = val;
        const input = this.root.querySelector('flow-input');
        if (input) {
            if (val) input.setAttribute('disabled', '');
            else input.removeAttribute('disabled');
        }
    }

    #processSubmit(form) {
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        this.emit('form:resend', {
            data,
            action: this.action,
            method: 'POST'
        });
    }
}

customElements.define('resend-verification-form', ResendVerificationForm);
